export default __webpack_public_path__ + "static/media/CopainPopotame.0879059e.png";